<template>
    <div class="nettdoc-intro">
        <img src="../assets/illu-icon-80-talk-plus.svg" alt="Speechbubbles with a Plus-Sign" />
        <br/>
        <img src="../assets/nett-doctor.svg" alt="nett.doctor" />

        <p class="nettdoc-intro__text">
            {{ ($t('introText')) }}
        </p>

        <Button text="diagnose me" :active="true" v-on:action="languageButtonEvent"/>

        <div class="nettdoc-intro__section intro__section--dark">
            <h2 class="nettdoc-header nettdoc-intro__section__header">{{ ($t('introTopHeading1')) }}</h2>
            <img src="../assets/nett-doctor.svg" alt="nett.doctor" style="width:170px;height:auto" />
            <div class="nettdoc-intro__section--illu">
                <img src="../assets/dr-illu-1.svg" alt="fill-in sheets" />
            </div>

            <h3 class="nettdoc-header">{{ $t('introFillFormHeading') }}</h3>
            <p class="nettdoc-intro__section__text">
                {{ ($t('introFillFormText')) }}
            </p>
        </div>

        <div class="nettdoc-intro__section">
            <div class="nettdoc-intro__section--illu">
                <img src="../assets/dr-illu-2.svg" alt="show sheets to doctor" />
            </div>
            
            <h3 class="nettdoc-header">{{ $t('introSummaryHeading') }}</h3>
            <p class="nettdoc-intro__section__text">
                {{ $t('introSummaryText') }}
            </p>
        </div>

        <div class="nettdoc-intro__section intro__section--dark">
            <h2 class="nettdoc-header nettdoc-intro__section__header">{{ $t('introTopHeading2') }}</h2>
            <img src="../assets/nett-doctor.svg" alt="nett.doctor" style="width:170px;height:auto;margin-bottom:50px" />
            
            <div>
                <div class="nettdoc-intro__section--wrap-image">
                    <img src="../assets/illu-icon-46-chat.svg" alt="blue Speechbubbles" />
                </div>
                <h3 class="nettdoc-header">{{ $t('introCommunicationHeading') }}</h3>
                <p class="nettdoc-intro__section__text">
                    {{ $t('introCommunicationText') }}
                </p>
            </div>

            <div>
                <div class="nettdoc-intro__section--wrap-image">
                    <img src="../assets/illu-icon-46-money-time.svg" alt="blue Speechbubbles" />
                </div>
                <h3 class="nettdoc-header">{{ $t('introTimeHeading') }}</h3>
                <p class="nettdoc-intro__section__text">
                    {{ $t('introTimeText') }}
                </p>
            </div>

            <div>
                <div class="nettdoc-intro__section--wrap-image">
                    <img src="../assets/illu-icon-46-mobile.svg" alt="blue Speechbubbles" />
                </div>
                <h3 class="nettdoc-header">{{ $t('introUsageHeading') }}</h3>
                <p class="nettdoc-intro__section__text">
                    {{ $t('introUsageText') }}
                </p>
            </div>

            <div>
                <div class="nettdoc-intro__section--wrap-image">
                    <img src="../assets/illu-icon-46-lock-safe.svg" alt="blue Speechbubbles" />
                </div>
                <h3 class="nettdoc-header">{{ $t('introDeviceHeading') }}</h3>
                <p class="nettdoc-intro__section__text">
                    {{ $t('introDeviceText') }}
                </p>
            </div>
        </div>

        <Button text="diagnose me" :active="true" v-on:action="languageButtonEvent" />

        </div>
    </div>
</template>

<script>
import Button from '../components/Button'
export default {
  name: 'Intro',
  components: {
      Button
  },
  methods: {
    languageButtonEvent: function () {
      this.$router.push(`/${this.$i18n.locale}/nettdoctor/disclaimer`)
    }
  }
}
</script>

<style lang="scss" scoped>
    .nettdoc-intro {
        padding: 40px 20px;
        text-align: center;
        &__text {
            font-family: Raleway;
            margin-bottom: 24px;
            color: var(--charcoal-grey);
        }
        &__start-with-language {
            margin-bottom: 50px;
            &--text {
                box-sizing:border-box;
                text-transform: uppercase;
                color: var(--dark-peach);
                font-weight: bold;
                padding: 24px 21px 26px 21px;
                cursor: pointer;
                display: grid;
                grid-template-columns: 10px auto 10px;
                img {
                    visibility: hidden;
                }
                &:hover {
                    img {
                        visibility: visible;
                    }
                }
            }
        }

        &__section {
            &--dark {
                background-color: var(--pale-grey);
            }
            &__header {
                margin: 0;
                text-transform: uppercase;
                font-weight: bold;
                font-size: 26px;
                padding: 50px 20px 4px 20px;
            }
            h3 {
                font-size: 20px;
                font-weight: 600;
                margin: 0;
            }
            &__text {
                font-size: 16px;
                padding: 0 20px 52px 20px;
            }
            &--wrap-image {
                width: 101px;
                height: 101px;
                margin: auto;
                margin-bottom: 20px;
                border-radius: 50%;
                border: 1px solid var(--light-sky-blue);
                background-color: var(--white);
                position: relative;
                img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            }
            &--illu {
                margin: 50px 0;
            }
        }
    }
</style>